 <div class="detail-row">
      <div class="w-100">
        <div class="field-box">
          <span class="field-label">EMAIL</span>
          <input
            type="email"
            [(ngModel)]="email"
            name="email"
            #emailCtrl="ngModel"
            required
            [pattern]="emailPattern"
            class="field-input"
          />
           <!-- Inline validation messages -->
          <small class="p-error"
                *ngIf="emailCtrl?.invalid && (emailCtrl?.dirty || emailCtrl?.touched)">
                <span *ngIf="emailCtrl?.errors?.['required']">
                  Email is required
                </span>
                <span *ngIf="emailCtrl.errors?.['pattern']">
                    Enter a valid email address
                </span>
          </small>
        </div>
      </div>
    </div>
    <div class="flex justify-content-end flex-wrap card-container flex-gap" >
     <button pButton type="button" label="Cancel" (click)="closeModal()" class="p-button-secondary" ></button>
    <div>
        <button pButton type="button" label="Save" (click)="saveContact()"
          class="p-button-primary" ></button>
    </div>
  </div>